import React, { useState, useEffect, useRef } from 'react';
import { Link, useHistory } from 'react-router-dom';
import ReactRouterPropTypes from 'react-router-prop-types';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import PVShopWrapper from '../../PVShopWrapper';
import PVSubCategoryTile from './PVSubCategoryTile';
import { getSubcategories } from '../../../../redux/products/category/actionsAsync';
import { selectors } from '../../../../redux/products/category';
import { selectActiveDealerKey } from '../../../../redux/userProfile/selectors';

const PVSubSubCategoryList = ({ match, apiGetSubCategories, category, dealerId }) => {
	const history = useHistory();
	const isMounted = useRef(null);
	const categoryPath = '';
	const [isLoaded, setIsLoaded] = useState(false);
	const [Link, setLink] = useState([]);
	const [DisplayName, setDisplayName] = useState('');
	const [ParentCategoryName, setParentCategoryName] = useState(match.params.categoryName);
	const [ParentCategoryDisplayName, setParentCategoryDisplayName] = useState(category.DisplayName);
	

	match.params.categoryName = match.params.subcategory;

	useEffect(() => {
		isMounted.current = true;
		return () => {
			isMounted.current = false;
		};
	}, []);

	useEffect(() => {
		if (!isLoaded || typeof category.Subcategories === 'undefined') {


			const { params } = match;
			const categoryHasData = category && category.Name;
			if (!categoryHasData && !category.isFetching) {
				apiGetSubCategories(params.categoryName)
					.then((response) => {

						if (isMounted.current) {
							const category = response.payload;
							//console.log(" category ="+JSON.stringify(category));
							//console.log(" categoryName="+JSON.stringify(category.categoryName));
							//console.log(" Subcategories DisplayName="+JSON.stringify(category.Subcategories[0].DisplayName));
							setLink(category.categoryName)
							setDisplayName(category.Subcategories[0].DisplayName)
							setIsLoaded(true);

						}
					})
					.catch(() => {
						history.push('/Error/404');
					});
			} else if (categoryHasData) {

				setIsLoaded(true);
			}
		}
	}, [match, category, isLoaded]);

	useEffect(() => {
		if (isMounted.current) {
			setIsLoaded(false);
			const { params } = match;
			apiGetSubCategories(params.categoryName)
				.then((response) => {

					if (isMounted.current) {
						const category = response.payload;

						//console.log("category.categoryName"+JSON.stringify(category.categoryName));
						//console.log("category.Subcategories[0].Name"+JSON.stringify(category.Subcategories[0].DisplayName));
						setLink(category.categoryName)
						setDisplayName(category.Subcategories[0].DisplayName)


						setIsLoaded(true);
					}
				})
				.catch(() => {
					history.push('/Error/404');
				});
		}
	}, [dealerId]);

	const breadcrumbs = [
		{
			sortOrder: 18,
			linkTarget: '/',
			linkText: 'Home',
		},
		{
			sortOrder: 19,
			linkTarget: `/Shop/Category/${ParentCategoryName}`,
			linkText: ParentCategoryDisplayName,
		},
		{
			sortOrder: 20,
			linkTarget: `/Shop/Category/${ParentCategoryName}/${category.categoryName}`,
			linkText: category.DisplayName,
		},
	];

	return (
		<React.Fragment>
			{isLoaded ? (
				<PVShopWrapper
					heading={category.DisplayName}
					banner={category.BannerImage}
					breadcrumbs={breadcrumbs}
					categorypath={categoryPath}
					webDescription={category.WebDescription}
					showViewAllLink={false}
					viewAllLink={Link}
					viewAllDisplayName={DisplayName}
				>
					<div className="row">
						<div className="col-xs-12">
							<div className="products products-list">
								{!category || !category.Subcategories
									? ''
									: category.Subcategories.map((subcat, index) => {
										if (index >= 0) {
											return (
												<PVSubCategoryTile
													key={subcat.Id}
													subcategory={subcat}
													categoryName={category.Name}
													parentCategory={ParentCategoryName}
													parentCategoryName={ParentCategoryName}
												/>
											);
										}
										return null;
									})}
							</div>
						</div>
					</div>
				</PVShopWrapper>
			) : (
				<div className="pv-spinner lg" />
			)}
		</React.Fragment>
	);
};

PVSubSubCategoryList.propTypes = {
	match: ReactRouterPropTypes.match.isRequired,
	dealerId: PropTypes.string,
	category: PropTypes.shape({
		receivedAt: PropTypes.number,
		isFetching: PropTypes.bool,
		Name: PropTypes.string,
		categoryName: PropTypes.string,
		DisplayName: PropTypes.string,
		BannerImage: PropTypes.string,
		Subcategories: PropTypes.arrayOf(
			PropTypes.shape({
				Name: PropTypes.string,
				ThumbnailImage: PropTypes.string,
				DisplayName: PropTypes.string,
			})
		),
	}).isRequired,
	apiGetSubCategories: PropTypes.func.isRequired,
};

PVSubSubCategoryList.defaultProps = {
	dealerId: '',
};

const mapStateToProps = (state, ownProps) => {
	const { match } = ownProps;
	const selectOptions = { parent: match.params.categoryName };
	return {
		category: selectors.selectCategory(state, selectOptions),
		dealerId: selectActiveDealerKey(state),
	};
};
const mapDispatchToProps = (dispatch) => {
	return {
		apiGetSubCategories: (categoryName) => dispatch(getSubcategories(categoryName)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(PVSubSubCategoryList);
